import { FC } from "react";
import { Stack, TextField } from "@mui/material";
import InsertChartOutlinedOutlinedIcon from "@mui/icons-material/InsertChartOutlinedOutlined";
import { VerifiedUserOutlined } from "@mui/icons-material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FilterTriggerComponentProps } from "@/components/common/select/dropdown-select/utils/types/filterTriggerComponentProps";

export const BudgetsAndAlertsHierarchySelectTrigger: FC<
  FilterTriggerComponentProps
> = ({ onClick, open, label, isProtected }) => {
  return (
    <TextField
      fullWidth
      size="small"
      label="Select Billing Report"
      onClick={onClick}
      focused={open}
      value={label}
      InputProps={{
        readOnly: true,
        endAdornment: open ? (
          <ArrowDropUpIcon fontSize="small" sx={{ color: "grey.600" }} />
        ) : (
          <ArrowDropDownIcon fontSize="small" sx={{ color: "grey.600" }} />
        ),
        startAdornment: (
          <Stack direction="row" spacing={0.5} alignItems="center" mr={0.5}>
            <InsertChartOutlinedOutlinedIcon fontSize="small" />
            {isProtected && <VerifiedUserOutlined sx={{ fontSize: 16 }} />}
          </Stack>
        ),
      }}
    />
  );
};
